import { useCloseUnlessOrgNetwork } from '../hooks/useCloseWhenMissing'
import { useParams, useSearchParams } from 'react-router-dom'
import DialogContent from '@mui/material/DialogContent'
import IconNode from './IconNode'
import AddNode from './AddNode'
import Modal from './Modal'
import { useModalClose } from '../hooks/useModalClose'
import { REGEX_VALID_DOMAIN } from '../constants'

type Props = {
  inline?: boolean
}

export default function ModalNode({ inline }: Readonly<Props>) {
  const { networkId } = useParams()
  // ⚠ An id in the path that is not an object of the active org sends the reader home (app#475).
  useCloseUnlessOrgNetwork(networkId)
  const [searchParams] = useSearchParams()
  const { open, handleClose } = useModalClose('/', inline)
  // ⚠⚠ `?name=` goes into the install commands that the user runs as root or as an
  // administrator, and NameForm checks typed input only. So a name from the URL must
  // be a DNS label, as the router requires, or the page ignores it. Otherwise a link
  // such as `?name=x';iex(irm …)#` puts code into the Windows command, after the key.
  const urlName = (searchParams.get('name') || '').trim().toLowerCase()
  const initialName = REGEX_VALID_DOMAIN.test(urlName) ? urlName : ''

  return (
    <Modal
      open={open}
      inline={inline}
      maxWidth="md"
      onClose={inline ? undefined : handleClose}
      color="node.main"
      icon={<IconNode type="node" width={54} height={54} outline plus />}
    >
      <DialogContent>
        <AddNode networkId={networkId} initialName={initialName} />
      </DialogContent>
    </Modal>
  )
}
